module.exports = __webpack_public_path__ + "img/phoenix_kedel_0.202c29ac.png";